<template>
    <div v-loading="dataLoading">
        <el-form
            v-if="data && formData"
            :model="formData"
            ref="formData"
            label-position="top"
        >
            <div class="group">
                <div class="page-group-title"><span>基本信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单ID: </span>{{data.id}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单编号: </span>{{data.sn}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付状态: </span>{{data.paymentStatus == 1  ? '未支付' : '已支付'}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单状态: </span>{{orderStatus.get(data.orderStatus)}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">授权状态: </span>						
						{{data.preAuthStatus ? preAuthStatus.get(data.preAuthStatus) : '无'}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">候补状态: </span>{{alternateStatus.get(data.alternateStatus) || '-'}}</el-col>
						<!-- 候补完成的单独展示候补成功时间 -->
						<el-col v-if="data.alternateStatus == 3 && data.alternateTime" :xs="24" :sm="12" :md="8"><span class="color-info">候补成功时间: </span>{{data.alternateTime}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">托售状态: </span>{{data.consignStatusView}}</el-col>
                        <el-col v-if="data.thirdAccountName" :xs="24" :sm="12" :md="8"><span class="color-info">业务渠道: </span>{{data.thirdAccountName}}</el-col>
                        <el-col v-if="data.thirdOrderId" :xs="24" :sm="12" :md="8"><span class="color-info">外部渠道订单编号: </span>{{data.thirdOrderId}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">定时购状态: </span>{{data.preBuyStatusView ? data.preBuyStatusView : '无'}}</el-col>
                        <!-- 定时购成功的单独展示定时购成功时间（出票时间） -->
                        <el-col v-if="data.preBuyStatus == 3 && data.preBuySuccessTime" :xs="24" :sm="12" :md="8"><span class="color-info">定时购成功时间: </span>{{data.preBuySuccessTime}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单终端: </span>{{data.terminal}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单时间: </span>{{data.createTime}}</el-col>
						<el-col :xs="24" :sm="12" :md="8" v-if="data && data.cancelTime"><span class="color-info">取消时间: </span>{{data.cancelTime}}</el-col>
                    </el-row>
                 </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>演出信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24"><h3>{{data.goodName}}</h3></el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">演出ID: </span>{{data.goodId}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">演出城市: </span>{{data.activityCity}}</el-col>

                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">演出场地: </span>{{data.siteName}}</el-col>
                    </el-row>
                    <el-table
                        :data="data.sessionInfo"
                        border
                        style="width: 100%"
                        size="small"
                        stripe
                        class="MT20"
                        >
                        <el-table-column prop="id" label="场次ID"></el-table-column>
                        <el-table-column prop="name" label="场次名称"></el-table-column>
                    </el-table>

                 </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>购票人信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户ID: </span>{{data.createUser}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户名: </span>{{data.buyerName}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">账号手机: </span>{{data.buyerUserPhone}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">身份: </span>{{data.buyerUserType}}</el-col>
                    </el-row>
                 </el-card>
            </div>
            <div v-if="data.ticketType == 2" class="group MT20">
                <div class="page-group-title">
                    <span>收货信息</span> 
                    <el-button v-if="$utils.have('/activiOrder/saveOrderAddr')" type="primary" plain size="mini" @click="handleEditAddress()">修改</el-button>
                </div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8">
                            <span class="color-info">收货人姓名: </span>{{data.customerName}}
                            <!-- <el-form-item prop="customerName" label="收货人姓名:" :rules="[{required: true, message: '请输入收货人姓名'}]">
                                <el-input v-model.trim="formData.customerName" placeholder="请输入收货人姓名" maxlength="20" size="medium"></el-input>
                            </el-form-item> -->
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <span class="color-info">联系手机: </span>+{{formData.areaCode}} {{data.telephone}}
                            <!-- <el-form-item prop="telephone" label="联系手机:" :rules="[{required: true, message: '请输入联系手机'}]">
                                <el-input class="input-with-select" v-model.trim="formData.telephone" placeholder="请输入联系手机" maxlength="20" size="medium">
                                    <el-select v-model="formData.areaCode" slot="prepend" placeholder="请选择区号">
                                        <el-option v-for="(item,index) in countryList" :key="index" :label="`+${item.code}`" :value="item.codeView">
                                            +{{item.code}} {{item.name}}
                                        </el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item> -->
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <span class="color-info">收货省市: </span>{{data.provinceName}} {{data.cityName }}
                            <!-- <el-form-item prop="city" label="收货省市:" :rules="[{required: true, message: '请选择收货省份城市'}]">
                                <el-cascader
                                    v-model="formData.city"
                                    :options="cityList"
                                    filterable
                                    :props="{label:'name',children:'cityList',value:'name'}"
                                    size="medium"
                                    style="width:100%"
                                    ref="cityCascader"
                                    @change="changeCity">
                                </el-cascader>
                            </el-form-item> -->
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <span class="color-info">收货地址: </span>{{data.address}}
                            <!-- <el-form-item prop="address" label="收货地址:" :rules="[{required: true, message: '请输入收货地址'}]">
                                <el-input v-model.trim="formData.address" placeholder="请输入收货地址" maxlength="100" size="medium"></el-input>
                            </el-form-item> -->
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <span class="color-info">快递公司: </span>{{data.expressName || '-'}}
                            <!-- <el-form-item prop="expressId" label="快递公司:" :rules="[{required: true, message: '请输入快递公司'}]">
                                <el-select v-model="formData.expressId" size="medium" placeholder="请选择快递公司">
                                    <el-option v-for="(item,index) in expressList" :key="index" :value="item.expressId" :label="item.expressName"></el-option>
                                </el-select>
                            </el-form-item> -->
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <span class="color-info">运单号: </span>{{data.expressNo || '-'}}
                            <!-- <el-form-item prop="expressNo" label="运单号:" :rules="[{required: true, message: '请输入运单号'}]">
                                <el-input v-model.trim="formData.expressNo" placeholder="请输入运单号" maxlength="40" size="medium"></el-input>
                            </el-form-item> -->
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>票品信息</span></div>
                <div class="MT20">
                    <el-card v-for="(item,index) in data.activityOrderTicketDetailVOS" :key="index" shadow="never" class="MT10">
                        <el-row :gutter="40">
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">票品名称: </span>{{item.skuName}}</el-col>
							<el-col :xs="24" :sm="12" :md="8"><span class="color-info">票品价格: </span>{{item.price}}</el-col>
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">数量: </span>{{item.num}}</el-col>
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">所属场次: </span>{{item.sessionName}}</el-col>
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">开演时间: </span>{{item.startTime}}</el-col>
                            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">票品性质: </span>{{item.ticketTypeName}}</el-col>
                            <!-- <el-col :xs="24" :sm="12" :md="8"><span class="color-info">购票方式: </span>{{item.buyType}}</el-col> -->
                        </el-row>
                        <el-table
                            :data="item.orderPerformers"
                            border
                            style="width: 100%"
                            size="small"
                            stripe
                            class="MT20"
                            >
								<el-table-column type="expand" label="展开">
								    <template slot-scope="scope">
								        <template v-if="scope.row.orderTicketLogs && scope.row.orderTicketLogs.length > 0">
								            <div v-for="(items,index) in scope.row.orderTicketLogs" :key="index">
								                <span>{{items.logTime}} {{items.content}}</span>                                
								            </div>
								        </template>
								        <div v-else>暂无信息</div>
								    </template>
								</el-table-column>
								<el-table-column prop="ticketCodeId" label="门票ID"></el-table-column>
                                <el-table-column prop="seatName" label="座位号/排队序号" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="name" label="观演人" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="documentType" label="证件类型">
                                    <template slot-scope="scope">
                                        {{documentType.get(scope.row.documentType)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="documentNumber" label="证件号码" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="accountId" label="对应账号ID"></el-table-column>
                                <el-table-column prop="accountPhone" label="对应账号手机" min-width="120"></el-table-column>
                                <el-table-column fixed="right" label="操作" width="200">
                                    <template slot-scope="scope">
                                        <el-button
                                            v-if="(data.paymentStatus === 1 &&  data.orderStatus === 6 ) || data.orderStatus === 7 "
											type="text"
											size="small"
                                            @click="resetLimit(item,scope.$index)"
											>重置限购</el-button>   
                                        <el-button
                                            v-if="scope.row.canUpdateBindInfo && $utils.have('/activiOrder/savePerformer')"
                                            type="text"
                                            size="small"
                                            @click="$refs.orderPerformersEdit.show(scope.row,index,scope.$index)"
                                            >编辑观演人</el-button>
										<el-button
                                            v-if="scope.row.canUpdateAcceptUser"
											type="text"
											size="small"
											@click="$refs.orderPerformersGift.show(scope.row,index,scope.$index)" 
											>修改接收人</el-button>
                                    </template>
                                </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>支付信息</span></div>
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="40">
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付渠道: </span>{{data.payPlatformName}}</el-col>
                        <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付平台交易号: </span>{{data.outTradeNo}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付时间: </span>{{data.payTime}}</el-col>
					</el-row>
					<div class="MT20" style="line-height: 25px;">
					<div><span class="color-info">订单总价: </span>{{data.totalAmountStr}}</div>
					<div><span class="color-info">票品金额: </span>票价{{data.activityOrderTicketDetailVOS[0].price}} * 票数{{data.activityOrderTicketDetailVOS[0].num}} = {{data.totalAmountStr}}</div>
					<div><span class="color-info">候补服务费: </span><template v-if="data && data.alternateFee && data.alternateFeeRatio">{{data.alternateFee}}（{{data.alternateFeeRatio}}）</template></div>
					<!-- <div><span class="color-info">购票总数: </span>{{data.payNum}}</div>   -->                    
				   <div><span class="color-info">优惠金额: </span>
						<span class="color-blue" v-if="data.couponId"><el-link :href="`/promotion/showCoupon/list?type=1&value=${data.couponId}`"  class="blue"  target="_blank">
						优惠券 - {{data.couponSubsidyView}}({{data.couponId}}) :</el-link> </span> {{data.couponDiscountView}}
						<span class="color-blue" v-if="data.randomDiscountView">(立减金额: {{data.randomDiscountView}})</span>
						<span class="color-blue" v-if="data.otherDiscountView">(其它优惠： {{data.otherDiscountView}})</span>
					</div>
					<div><span class="color-info">订单应付: </span>{{data.payableAmountStr}}</div>
					<div><span class="color-info">实际支付: </span>{{data.realPayAmountStr}}</div>
					<!-- <div>
						<span class="color-info">乐迷服务费: </span>{{data.userServiceFee}}
					</div> -->
					<div><span class="color-info">托售服务费(售后扣款相关): </span> <template v-if="data && data.consignFee && data.consignFeeRatio">{{data.consignFee}}（{{data.consignFeeRatio}}）</template></div>
                     </div>   
                    
                 </el-card>
            </div>
            <div v-if="data.ticketCodeVOS" class="group MT20">
                <div class="page-group-title"><span>核验信息</span></div>
                <el-table
                    :data="data.ticketCodeVOS"
                    border
                    style="width: 100%"
                    size="small"
                    stripe
                    class="MT20"
                    >
                    <el-table-column prop="ticketName" label="票品名称"></el-table-column>
                    <el-table-column prop="code" label="票品code"></el-table-column>
                    <el-table-column prop="num" label="核销数量"></el-table-column>
                    <el-table-column prop="exchangeTime" label="核销时间"></el-table-column>
                    <el-table-column prop="modifyUserIdentity" label="核销人身份"></el-table-column>
                    <el-table-column prop="modifyUser" label="核销人ID"></el-table-column>
                </el-table>
            </div>
            <div v-if="data.afterSales && data.afterSales.length > 0" class="group MT20">
                <div class="page-group-title"><span>售后信息</span></div>
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">取消时间: </span>{{data.cancelTime}}</el-col>
                    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">取消人: </span>{{data.cancelName}}</el-col>
                </el-row>
                 <el-table
                    :data="data.afterSales"
                    border
                    style="width: 100%"
                    size="small"
                    stripe
                    class="MT20"
                    :key="uuid"
                    >
                    <el-table-column label="售后次数">
                         <template slot-scope="scope">{{scope.$index + 1}}</template>
                    </el-table-column>
					<el-table-column label="售后来源">
					    <template slot-scope="scope">{{source.get(scope.row.source)}}</template>
					</el-table-column>
                    <el-table-column label="售后状态">
                        <template slot-scope="scope">{{afterSalesStatus.get(scope.row.afterSalesStatus)}}</template>
                    </el-table-column>					
                    <el-table-column prop="refundNum" label="申请退票数量"></el-table-column>
					<el-table-column prop="refundAmount" label="申请退款金额"></el-table-column>
					<el-table-column label="申请时退票手续费（比例）">
						<template slot-scope="scope" >
							{{scope.row.refundFeeStr}} <span v-if="scope.row.refundFeeRatioStr">（{{scope.row.refundFeeRatioStr}}）</span>
						</template>
					</el-table-column>
					<el-table-column label="审核后确认退款金额">
						<template slot-scope="scope">
							<span v-if="scope.row.afterSalesStatus == 3 || scope.row.afterSalesStatus == 4"> {{scope.row.recordRefundAmount}}</span>
						</template>
					</el-table-column>
					<el-table-column  label="审核后确认退票手续费（比例）">		
						<template slot-scope="scope">
							<template v-if="scope.row.afterSalesStatus == 3 || scope.row.afterSalesStatus == 4">
							{{scope.row.recordRefundFeeStr}} （{{scope.row.recordRefundFeeRatioStr}}）
                            <el-popover v-if="$utils.have('/activiOrder/upRefundRule') && data.upRefundFeeStatus == 1" title="修改退票手续费比例">
                                <div class="MT20">
                                    <el-input-number v-model="ratio" :precision="2" :step="0.01" :min="0" :max="100" size="small" @change="$forceUpdate()"></el-input-number>%
                                    <div class="MT20" style="text-align: right;">
                                        <el-button size="mini" type="text" @click="popoverHide(scope.$index)">取消</el-button>
                                        <el-button type="primary" size="mini" @click="upRefundRule(scope.$index)">确定</el-button>
                                    </div>
                                </div>
                                <el-button slot="reference" type="text" icon="el-icon-edit" size="mini" @click="ratioFun(scope.row.recordRefundFeeRatioStr)"></el-button>
                            </el-popover>
							</template>
						</template>
					</el-table-column>
                    <!-- <el-table-column prop="refundAmount" label="应退金额"></el-table-column> -->
                    <el-table-column prop="refundTime" label="实际退款时间"></el-table-column>
                </el-table>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>订单备注</span></div>
                <div class="MT20">
                    <el-form-item prop="systemRemark">
                        <el-input v-model="formData.systemRemark" type="textarea" :rows="4" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="group MT20">
                <el-button @click="goBack">返回</el-button>
				<el-button
				    v-if="data.orderStatus == 7 && $utils.have('/activiOrder/restore') && ( !data.alternateStatus || data.alternateStatus==3 ) && (data.afterSales.length > 0 && data.afterSales[data.afterSales.length-1].afterSalesStatus <= 3) "
				    type="success"				    
					icon="el-icon-refresh"
					@click="backCancel(data)"
				    >恢复取消</el-button>  
                <el-button
                    v-if="$utils.have('/activiOrder/save')"
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >保存</el-button
                >
				<el-button
				    v-if="data.invoiceStatus == 0 && $utils.have('/invoice/record/apply')"
				    type="primary"
				    @click="Applyinvoice(data)"	    
				    >申请发票</el-button
				>
				<el-button
				    v-if="data.invoiceStatus != 0 && data.invoiceStatus != -1 && $utils.have('/invoice/record/list')"
				    type="primary"
				    :loading="btnLoading"
					@click="invoiceList(data)"
				    >发票记录</el-button
				>
				<el-button
				    v-if="$utils.have('/activiOrder/forceCancel') && data.paymentStatus == 2 && [2, 3, 4, 5].includes(data.orderStatus)"
				    type="primary"
					@click="cancel()"
				    >强制取消订单</el-button
				>
            </div>
        </el-form>
		<el-dialog title="强制取消订单" :visible.sync="dialogVisible" width="600px" center v-if="batchData">
			<div class="dialog-content">
				<div>
				   <p class="color-danger">取消之前请确认核对：</p>
				   <p class="MT10">演出ID：{{batchData.activityId}} <span v-if="batchData && batchData.orderStatus == 4 " class="color-danger">（实体票，已发货）</span></p>
				   <p class="MT10">演出名称：{{batchData.activityName}}</p>
				   <p class="MT10 color-danger">需取消订单数:{{batchData.cancelNum}},包含以下票品</p>
				   <div class="temp-table" v-if="batchData && batchData.ticketList && batchData.ticketList.length > 0">
				       <el-table
				           :data="batchData.ticketList"
				           style="width: 100%"
				           size="small"
				           border
				       >
				           <el-table-column prop="ticketName" label="票品&场次名称"></el-table-column>
				           <el-table-column prop="userName" label="观演人"></el-table-column>
				           <el-table-column prop="orderTime" label="下单时间"></el-table-column>	
				           <el-table-column prop="num" label="数量" min-width="50"></el-table-column>				           
				       </el-table>
				   </div>
				   <template v-if="batchData && batchData.cancelRecord && batchData.cancelRecord.length > 0">
				   <p class="MT20">当前演出用户取消记录:</p>
				   <div class="temp-table MT10">
					   <el-table
						   :data="batchData.cancelRecord"
						   style="width: 100%"
						   size="small"
						   border
					   >
						   <el-table-column prop="ticketName" label="票品&场次名称"></el-table-column>
						   <el-table-column prop="userName" label="观演人"></el-table-column>
						   <el-table-column prop="orderTime" label="下单时间"></el-table-column>
						   <el-table-column prop="num" label="已取消订单数" min-width="30"></el-table-column>						           
					   </el-table>
					   <el-link class="link color-blue"  :href="`/activityManage/order/list?searchType=1&searchValue=${batchData.activityId}&searchType2=5&searchValue2=${batchData.userId}&orderStatus=7`" target="_blank">点击查看已取消订单</el-link>
				   </div>
				   					   
				   </template>
					   <!-- 关联的权益票订单（强制取消主票会同步取消权益票订单） -->
					   <template v-if="batchData && batchData.benefitOrderList && batchData.benefitOrderList.length > 0">
						   <p class="MT10 color-danger">该订单有关联的权益票订单,取消后将会同步取消以下权益票订单:</p>
						   <div class="temp-table">
							   <el-table
								   :data="batchData.benefitOrderList"
								   style="width: 100%"
								   size="small"
								   border
							   >
								   <el-table-column prop="orderSn" label="权益票订单编号" min-width="150"></el-table-column>
								   <el-table-column prop="ticketName" label="票品名称" show-overflow-tooltip></el-table-column>
								   <el-table-column label="实付金额" min-width="90">
									   <template slot-scope="scope">{{ (scope.row.paidAmount / 10000).toFixed(2) }}元</template>
								   </el-table-column>
								   <el-table-column label="订单状态" min-width="80">
									   <template slot-scope="scope">{{ benefitOrderStatusText(scope.row.orderStatus) }}</template>
								   </el-table-column>
							   </el-table>
						   </div>
					   </template>
					   <div class="MT20">
						   <small class="color-danger">*</small>取消原由：
					   <el-input type="textarea" v-model="reason" placeholder="请填写取消原由" maxlength="100" class="MT10"></el-input>
				   </div>
				   <div class="MT20">
					   <small class="color-danger">*</small>请选择是否需要扣除手续费：
				   		<el-select v-model="isCalculateRefundFee" placeholder="请选择是否需要扣除手续费" size="small" style="width: 100%;" class="MT10">				   		   
				   		    <el-option label="不扣除手续费" value="0"></el-option>
				   		    <el-option label="需要扣除手续费" value="1"></el-option>
							<el-option label="手动设置扣款百分比" value="2"></el-option>
				   		</el-select>
						<div class="MT10 "><small v-if="batchData.refundRule == 1"><span class="color-danger">注意:当前演出设置了退款手续费规则，请酌情选择是否扣除手续费!</span></small></div>
						<div v-if="batchData.orderStatus == 4" class="MT10 color-danger">注意：当前有订单属于实体票订单且已经发货，请酌情选择是否取消!</div>
				   </div>
				   <div class="MT20" v-if="isCalculateRefundFee == 2">
				   	<small class="color-danger">*</small>扣款百分比：
				   	<el-input-number v-model="refundFeeRatio" :min="0" :max="100" :precision="2" controls-position="right" size="mini" style="width: 200px;"></el-input-number> %
				   	<span class="ML20" v-if="refundFeeRatio">{{ ((batchData.orderAmount * refundFeeRatio) / 1000000).toFixed(2) }} 元</span>
				   </div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closePop()">取 消</el-button>
				<el-button type="primary" @click="forceCancelSubmit">确 定</el-button>
			</span>
		</el-dialog>
        <OrderPerformersEdit ref="orderPerformersEdit" @onUpdate="updateOrderPerformers" :orderId="id"></OrderPerformersEdit>
		<OrderPerformersGift ref="orderPerformersGift" @onUpdate="getDataDetail"></OrderPerformersGift>
		<apply-invoices ref="ApplyInvoices" @onUpdate="getDataDetail"></apply-invoices>
		<OrderAddressEdit v-if="data && data.ticketType == 2" ref="orderAddressEdit" @onUpdate="getDataDetail"></OrderAddressEdit>
    </div>
</template>

<script>

import OrderPerformersEdit from './components/orderPerformersEdit';
import OrderPerformersGift from './components/orderPerformersGift';
import ApplyInvoices from "./components/apply-invoices";
import OrderAddressEdit from './components/orderAddressEdit';
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{OrderPerformersEdit,OrderPerformersGift,ApplyInvoices,OrderAddressEdit},
    data(){

        return{
            dataLoading: false,
            redirect: this.$route.query.redirect || '/activityManage/order/list',
            data:null,
            formData:null,
            btnLoading: false,
            uuid: this.$utils.uuid(),
            ratio: 0,
			dialogVisible:false,
			batchData:null,
			reason:'主办同意单独退款',
			isCalculateRefundFee:'',
			ticketWalletData:[],
			refundFeeRatio:undefined
			
        }
    },
    computed:{
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'已发货'],
                [5,'已完成'],
                [6,'已过期'],
                [7,'已取消'],
            ])
        },
        documentType(){
            return new Map([
                [1,'身份证'],
                [2,'港澳居民来往内地通行证'],
                [3,'台湾居民来往大陆通行证'],
                [4,'护照'],
                [5,'外国人永久居留身份证'],
                [6,'港澳台居民居住证']
            ])
        },
		alternateStatus(){
            return new Map([
                [1,'待候补'],
                [2,'候补中'],
                [3,'候补完成'],
                [4,'候补失败'] 
            ])
        },
        afterSalesStatus(){
            return new Map([
                [1,'待审核'],
                [2,'待退货'],
                [3,'待退款'],
                [4,'已退款'],
                [5,'已拒绝'],
                [6,'已过期'],
            ])
        },
		preAuthStatus(){
		    return new Map([
		        [1,'待授权'],
		        [2,'已授权'],
		        [3,'取消授权']
		    ])
		},
		source(){
		    return new Map([
				[-1,'后台取消'],
				[0,'演出变动'],
		        [1,'用户申请'],
		        [2,'托售成功'],
		        [3,'候补失败'],
		        [4,'定时购失败'],
		        [5,'过期支付'],
		        [6,'支付取消'],
				[7,'库存异常'],
		    ])
		}
    },
    created(){
        if (this.id) {
            this.getDataDetail();
        }
    },
    methods:{
        //修改收货信息
        handleEditAddress(){
            this.$refs.orderAddressEdit.show(this.data);
        },
        
		ratioFun(num){			
			var numStr = parseFloat(num.replace("%", "")) || 0;
			this.ratio = numStr
		},
        //获取详情
        getDataDetail(type = 1) {
            this.dataLoading = type == 1 ? true : false;
            this.$request({
                url: "/activiOrder/detail",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = {...result};

                        if( this.data.afterSales && this.data.afterSales.length > 0 ){
                            this.data.afterSales = this.data.afterSales.map(item => {
                                item.refundFeeRatio = parseFloat( item.refundFeeRatioStr )
                                return item;
                            })  
                        }
                        this.formData = {
                            // customerName: result.customerName || '',
                            // areaCode:result.areaCode || '86_CN',
                            // telephone: result.telephone || '',
                            // address: result.address || '',
                            // expressId:result.expressId || '',
                            // expressNo:result.expressNo || '',
                            // provinceName: result.provinceName || '北京',
                            // cityName: result.cityName || '北京',
                            orderId: result.id,
                            // city: [result.provinceName || '北京',result.cityName || '北京'],
                            // orderPerformers:[],
                            systemRemark: result.systemRemark || '',
                        }
                    } else {
                        this.$message.error(msg || "获取订单详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取订单详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //权益票订单状态文案
        benefitOrderStatusText(status){
            const _map = { 1: '待处理', 2: '待发货', 3: '部分发货', 4: '已发货', 5: '已完成', 6: '已过期', 7: '已取消' };
            return _map[status] || '-';
        },
        cancel(){

        	this.$request({
        		url: "/activiOrder/batchCancelCheck",
        		method: "POST",
        		data: {
        		    searchType:4,
        			searchValue:this.data.sn,
					isForce:1
        		},
        	})
        		.then((res) => {
        			const { state, msg, result } = res.data;
        			if (state == 1) {
        				
        				if( result.errorInfo){
        					this.$alert(result.errorInfo, '取消订单', {confirmButtonText: '知道了'});
        				}
        				if( result.ticketList && result.ticketList.length > 0 ){
        					this.batchData = result        					
        					this.dialogVisible = true
        				}
        				
        			} else {
        				
        				this.$message.error(msg || "请求失败");
        			}
        		})
        		.catch(() => {
        			this.$message.error("请求错误");
        		})	
        	
        },
		closePop(){
			this.dialogVisible = false			
			this.isCalculateRefundFee = ''
			this.reason = '主办同意单独退款'
			this.refundFeeRatio = undefined
		},
        //设置观演人
        // setOrderPerformers(){
        //     const _array = [];
        //     this.data.activityOrderTicketDetailVOS.forEach((item,index) => {
        //         if(item.orderPerformers){
        //             item.orderPerformers.forEach( (v,i) => {
        //                 const _item = {
        //                     ...v
        //                 }
        //                 _array.push(_item)
        //             });
        //         }
        //     });
        //     this.formData.orderPerformers = _array;
        // },
		backCancel(data){
			var _cancelReasons = '';
			if( data && data.afterSales&& data.afterSales.length > 0 ){
				data.afterSales.forEach((item,index) => {
					_cancelReasons = item.cancelReason || '无'
				})
			}
			this.$confirm(`该订单于 ${data.cancelTime} 取消<br>取消原因：${_cancelReasons}`, '恢复取消', {
			    type: 'warning',
			    center: true,
			    closeOnClickModal: false,
			    dangerouslyUseHTMLString: true,
			}).then(() => {
			    this.$request({
			        url: "/activiOrder/restore",
			        method: "POST",
			        params: {
			            orderId: data.id
			        },
			    })
			        .then((res) => {
			            const { state, msg } = res.data;
			            if (state == 1) {
							this.$message.success("操作成功");
			                window.location.reload()
			            } else {
			                this.$message.error(msg || "请求失败");
			            }
			        })
			        			
				
			}).catch(() => {
			  
			})
		},
		Applyinvoice(data){
			this.$refs.ApplyInvoices.show(data);
		},
		invoiceList(data){
			this.$router.push({path: '/activityManage/invoice/list', query: {searchType: 4, searchValue: data.sn,status :-1 ,type :-1}})
		},
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    // this.setOrderPerformers();
                    this.$request({
                        url: "/activiOrder/save",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
								if (this.$refs.formData) {
								    this.$refs.formData.clearValidate();
								}
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //更新观演人
        updateOrderPerformers(data){
            this.$set(this.data.activityOrderTicketDetailVOS[data.sort].orderPerformers,data.index,{...data.data})
        },
        //重置限购
        resetLimit(obj,index){
            this.$confirm(`确认针对证件号<span class="color-danger">${obj.orderPerformers[index].documentNumber}</span>，<br>重置当前场次下<span class="color-danger">${obj.skuName}</span>的限购？`, '提示', {
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true
            }).then(() => {
                this.$request({
                    url: "/activiOrder/remakeBuyLimit",
                    method: "POST",
                    params: {
                        documentNumber: obj.orderPerformers[index].documentNumber,
                        documentType: obj.orderPerformers[index].documentType,
                        skuId: obj.skuID,
                        sessionId: obj.sessionId,
						orderId:this.id
                    },
                })
                    .then((res) => {
                        //处理成功回调
                        const { state, msg } = res.data;
                        if (state && state == 1) {
                            this.$message.success("操作成功");
                        } else {
                            return this.$message.error(msg || "操作失败");
                        }
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
            }).catch(() => {})
        },

        popoverHide(index){
            this.$nextTick(() => {
                this.uuid = this.$utils.uuid()
            })
        },
        upRefundRule(index){
			
            this.$request({
                url: "/activiOrder/upRefundRule",
                method: "POST",
                params: {
                    afterSalesId: this.data.afterSales[index].afterSalesId,
                    ratio: this.ratio * 10000,
                    orderId:this.id
                },
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("操作成功");
                        this.popoverHide();
                        setTimeout(() => {
                            this.getDataDetail(2);
                        }, 1000);
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .finally(() => {
                    // this.btnLoading = false;
                });
        },
		//强制取消
		forceCancelSubmit(){
			if( this.isCalculateRefundFee == ''){
				return this.$message.error("请选择是否需要扣除手续费");
			}
			if( this.reason == '' ){
				return this.$message.error("取消原由不能为空");
			}
			//关联权益票订单确认（强制取消主票会同步取消关联的权益票订单）
			if( this.batchData.benefitOrderList && this.batchData.benefitOrderList.length > 0 ){
				const _sns = this.batchData.benefitOrderList.map(v => v.orderSn).join('、');
				this.$confirm(`该订单有关联的权益票订单:<span class="color-danger">${_sns}</span>,将会同步取消对应权益票订单,确认取消?`, '取消订单', {
					type: 'warning',
					confirmButtonText: '确认取消',
					cancelButtonText: '再想想',
					showClose: false,
					customClass: 'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,
				}).then(() => {
					this.forceCancelSubmitRun();
				}).catch(() => {})
				return;
			}
			this.forceCancelSubmitRun();
		},
		forceCancelSubmitRun(){
			if( this.batchData.orderStatus == 4 ){
				this.$confirm(`注意:当前订单包含<span class="color-danger">实体票订单，且已经发货</span>，取消以后可能存在无法收回门票的风险。<br>是否确认<span class="color-danger">继续取消</span>?`, '取消订单', {
					type: 'wraning',
					confirmButtonText: '继续取消',
					cancelButtonText:'返回',
					showClose:false,
					customClass:'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,					
				}).then(() => {
					this.cancelFun()
				}).catch(() => {
					this.closePop()
				}) 
				
			}else{
				this.cancelFun()
			}			
			    
		},
		cancelFun(){
			if (this.isCalculateRefundFee == 2) {
				if (this.refundFeeRatio == undefined ) {
					return this.$message.warning('请填写扣款百分比');					
				}
				if (this.refundFeeRatio == 0) {
					return this.$message.warning('扣款百分比必须大于0');					
				}			        
			}
			this.batchLoading2 = true
			this.$request({
			    url: "/activiOrder/forceCancel",
			    method: "POST",
			    params:{
					orderId:this.batchData.orderIds[0],					
					isCalculateRefundFee:this.isCalculateRefundFee,
					reason:this.reason,
					refundFeeRatio:this.refundFeeRatio
				} 
			})
			    .then((res) => {
			        const { state, msg, result } = res.data;
			        if (state == 1) {
						this.$message.success("操作成功");
						this.getDataDetail();
						this.dialogVisible = false
						this.isCalculateRefundFee = ''
						this.reason = '主办同意单独退款'
						this.refundFeeRatio = undefined
						
			        } else {			            
			            this.$message.error(msg || "请求失败");						
						this.isCalculateRefundFee = ''
						this.reason = '主办同意单独退款'
						this.refundFeeRatio = undefined
			        }
			    })
			    .catch(() => {
			        this.$message.error("请求错误");
			    })
		},
		
    }
}
</script>

<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
    }
}
.blue{
   color:#409eff;
   text-decoration:none;
}
::v-deep .el-link{
	vertical-align:top
}
.page-group-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>